export default __webpack_public_path__ + "static/media/32_desktop.277e813c.jpg";